export enum AgentDetailAction {
  CHANGE_TO_ANOTHER_CHANNEL = 'CHANGE_TO_ANOTHER_CHANNEL',
  CLONE_AGENT = 'CLONE_AGENT',
  UPDATE_AGENT = 'UPDATE_AGENT',
}
